import { useState, useEffect } from "react";
import { getBroadcastStatus } from "../services/usersService";

export interface ProfileStatus {
  canBroadcast: boolean;
  missingFields: string[];
  message: string;
  loading: boolean;
  error: string | null;
}

/**
 * BR-26: Hook to check broadcast readiness (profile completeness).
 * Calls GET /api/users/profile/broadcast-status.
 */
export function useProfileStatus(): ProfileStatus {
  const [status, setStatus] = useState<ProfileStatus>({
    canBroadcast: false,
    missingFields: [],
    message: "",
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const { data } = await getBroadcastStatus();
        if (cancelled) return;
        setStatus({
          canBroadcast: data.canBroadcast,
          missingFields: data.missingFields || [],
          message: data.message || "",
          loading: false,
          error: null,
        });
      } catch (e: unknown) {
        if (cancelled) return;
        setStatus((prev) => ({
          ...prev,
          loading: false,
          error: "Failed to check profile status",
        }));
      }
    }

    check();
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
}
